import React from 'react';
import { LoggedInNav } from '../components/LoggedInNav';
import { SearchIcon, ChevronDownIcon, PlusCircleIcon, SmileIcon, PaperclipIcon, SendIcon, ThumbsUpIcon, MessageSquareIcon, ShareIcon, BookmarkIcon, MoreHorizontalIcon, ClockIcon, CalendarIcon, UsersIcon, CheckCircleIcon, ExternalLinkIcon, InfoIcon } from 'lucide-react';
export function SlackMessage() {
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-4128">
      <LoggedInNav data-id="element-4129" />
      <main className="max-w-6xl mx-auto px-4 py-8" data-id="element-4130">
        <h1 className="text-2xl font-bold mb-6" data-id="element-4131">Meeting Briefs in Slack</h1>
        <p className="mb-8 text-[#F5F7FA] text-opacity-80" data-id="element-4132">
          Get your AI-powered meeting briefs delivered directly to Slack. Stay
          prepared without leaving your team's communication hub.
        </p>
        {/* Slack Interface */}
        <div className="bg-white rounded-lg overflow-hidden shadow-xl mb-8 max-w-4xl mx-auto" data-id="element-4133">
          {/* Slack Header */}
          <div className="bg-[#350D36] text-white px-4 py-2 flex items-center justify-between" data-id="element-4134">
            <div className="flex items-center" data-id="element-4135">
              <span className="font-bold" data-id="element-4136">Prepz Workspace</span>
              <ChevronDownIcon className="h-4 w-4 ml-1" data-id="element-4137" />
            </div>
            <div className="relative" data-id="element-4138">
              <input type="text" placeholder="Search Prepz" className="bg-[#5D3D5E] text-white rounded px-3 py-1 text-sm w-64 focus:outline-none" data-id="element-4139" />
              <SearchIcon className="absolute right-3 top-1.5 h-4 w-4 text-[#BDB6BE]" data-id="element-4140" />
            </div>
          </div>
          {/* Channel Header */}
          <div className="bg-[#3F0E40] text-white px-4 py-2 flex items-center justify-between" data-id="element-4141">
            <div className="flex items-center" data-id="element-4142">
              <div className="h-4 w-4 mr-2 text-[#BDB6BE]" data-id="element-4143" />
              <span className="font-bold" data-id="element-4144">meeting-prep</span>
              <InfoIcon className="h-4 w-4 ml-2 text-[#BDB6BE]" data-id="element-4145" />
            </div>
          </div>
          {/* Messages Area */}
          <div className="bg-[#1A1D21] h-[600px] overflow-y-auto flex flex-col" data-id="element-4146">
            {/* Date Divider */}
            <div className="flex items-center justify-center my-4" data-id="element-4147">
              <div className="h-px bg-[#424242] flex-grow max-w-xs" data-id="element-4148"></div>
              <span className="px-4 text-[#9B9B9B] text-xs" data-id="element-4149">Today</span>
              <div className="h-px bg-[#424242] flex-grow max-w-xs" data-id="element-4150"></div>
            </div>
            {/* Prepz Bot Message */}
            <div className="px-6 py-2 hover:bg-[#222529]" data-id="element-4151">
              <div className="flex items-start mb-1" data-id="element-4152">
                <div className="w-10 h-10 rounded mr-3 overflow-hidden flex-shrink-0" data-id="element-4153">
                  <div className="w-full h-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] font-bold" data-id="element-4154">
                    PB
                  </div>
                </div>
                <div data-id="element-4155">
                  <div className="flex items-center" data-id="element-4156">
                    <span className="font-bold text-white" data-id="element-4157">Prepz Bot</span>
                    <span className="text-[#9B9B9B] text-xs ml-2" data-id="element-4158">9:32 AM</span>
                  </div>
                  <div className="mt-1 text-white" data-id="element-4159">
                    <p className="mb-2" data-id="element-4160">
                      :wave: Good morning! Here's your meeting brief for today:
                    </p>
                    {/* Meeting Brief Card */}
                    <div className="border-l-4 border-[#C8F169] bg-[#222529] rounded-r rounded-bl p-4 my-2" data-id="element-4161">
                      <div className="flex items-center justify-between mb-4" data-id="element-4162">
                        <div className="flex items-center" data-id="element-4163">
                          <CalendarIcon className="h-5 w-5 text-[#C8F169] mr-2" data-id="element-4164" />
                          <div data-id="element-4165">
                            <h3 className="font-medium text-white" data-id="element-4166">
                              Quarterly Strategy Meeting
                            </h3>
                            <div className="flex items-center text-[#9B9B9B] text-sm" data-id="element-4167">
                              <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-4168" />
                              Today, 10:00 AM - 11:30 AM
                            </div>
                          </div>
                        </div>
                        <div className="bg-[#2C3E50] px-3 py-1 rounded text-xs text-[#C8F169]" data-id="element-4169">
                          Important
                        </div>
                      </div>
                      <div className="mb-4" data-id="element-4170">
                        <h4 className="text-[#9B9B9B] text-sm mb-1" data-id="element-4171">
                          Meeting Brief
                        </h4>
                        <p className="text-[#E2E2E2]" data-id="element-4172">
                          This quarterly strategy meeting will focus on
                          reviewing Q3 results and planning for Q4 initiatives.
                          The team will discuss current project status, resource
                          allocation, and upcoming market opportunities.
                        </p>
                      </div>
                      <div className="mb-4" data-id="element-4173">
                        <h4 className="text-[#9B9B9B] text-sm mb-2" data-id="element-4174">
                          Attendees (5)
                        </h4>
                        <div className="space-y-2" data-id="element-4175">
                          <div className="flex items-center justify-between bg-[#2C2C2C] p-2 rounded" data-id="element-4176">
                            <div className="flex items-center" data-id="element-4177">
                              <div className="w-8 h-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xs font-bold mr-2" data-id="element-4178">
                                WS
                              </div>
                              <div data-id="element-4179">
                                <div className="text-white text-sm" data-id="element-4180">
                                  William Smith
                                </div>
                                <div className="text-[#9B9B9B] text-xs" data-id="element-4181">
                                  VP of Product, TechCorp
                                </div>
                              </div>
                            </div>
                            <a href="#" className="text-[#3B82F6] text-xs flex items-center" data-id="element-4182">
                              <ExternalLinkIcon className="h-3 w-3 mr-1" data-id="element-4183" />
                              LinkedIn
                            </a>
                          </div>
                          <div className="flex items-center justify-between bg-[#2C2C2C] p-2 rounded" data-id="element-4184">
                            <div className="flex items-center" data-id="element-4185">
                              <div className="w-8 h-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xs font-bold mr-2" data-id="element-4186">
                                AJ
                              </div>
                              <div data-id="element-4187">
                                <div className="text-white text-sm" data-id="element-4188">
                                  Alice Johnson
                                </div>
                                <div className="text-[#9B9B9B] text-xs" data-id="element-4189">
                                  Director of Marketing, TechCorp
                                </div>
                              </div>
                            </div>
                            <a href="#" className="text-[#3B82F6] text-xs flex items-center" data-id="element-4190">
                              <ExternalLinkIcon className="h-3 w-3 mr-1" data-id="element-4191" />
                              LinkedIn
                            </a>
                          </div>
                          <button className="text-[#3B82F6] text-xs" data-id="element-4192">
                            View all 5 attendees
                          </button>
                        </div>
                      </div>
                      <div className="mb-4" data-id="element-4193">
                        <h4 className="text-[#9B9B9B] text-sm mb-2" data-id="element-4194">
                          Business Insights
                        </h4>
                        <div className="space-y-2" data-id="element-4195">
                          <div className="flex items-start" data-id="element-4196">
                            <CheckCircleIcon className="h-4 w-4 text-[#C8F169] mt-0.5 mr-2 flex-shrink-0" data-id="element-4197" />
                            <p className="text-[#E2E2E2] text-sm" data-id="element-4198">
                              Company grew 27% in Q3, exceeding the market
                              average of 18%
                            </p>
                          </div>
                          <div className="flex items-start" data-id="element-4199">
                            <CheckCircleIcon className="h-4 w-4 text-[#C8F169] mt-0.5 mr-2 flex-shrink-0" data-id="element-4200" />
                            <p className="text-[#E2E2E2] text-sm" data-id="element-4201">
                              New product launch scheduled for early Q4 with 85%
                              readiness
                            </p>
                          </div>
                          <div className="flex items-start" data-id="element-4202">
                            <CheckCircleIcon className="h-4 w-4 text-[#C8F169] mt-0.5 mr-2 flex-shrink-0" data-id="element-4203" />
                            <p className="text-[#E2E2E2] text-sm" data-id="element-4204">
                              Customer retention improved by 12% following the
                              last initiative
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-end" data-id="element-4205">
                        <a href="#" className="bg-[#3B82F6] hover:bg-[#2D6BCD] text-white px-4 py-1.5 rounded text-sm" data-id="element-4206">
                          View Full Brief
                        </a>
                      </div>
                    </div>
                    <p data-id="element-4207">
                      Need any specific information about this meeting? Just
                      ask!
                    </p>
                  </div>
                </div>
              </div>
              {/* Message Actions */}
              <div className="ml-12 mt-2 flex items-center space-x-3 text-[#9B9B9B]" data-id="element-4208">
                <button className="flex items-center text-xs hover:text-white" data-id="element-4209">
                  <ThumbsUpIcon className="h-3.5 w-3.5 mr-1" data-id="element-4210" />
                  <span data-id="element-4211">1</span>
                </button>
                <button className="flex items-center text-xs hover:text-white" data-id="element-4212">
                  <MessageSquareIcon className="h-3.5 w-3.5 mr-1" data-id="element-4213" />
                  <span data-id="element-4214">Reply</span>
                </button>
                <button className="flex items-center text-xs hover:text-white" data-id="element-4215">
                  <ShareIcon className="h-3.5 w-3.5 mr-1" data-id="element-4216" />
                  <span data-id="element-4217">Share</span>
                </button>
                <button className="flex items-center text-xs hover:text-white" data-id="element-4218">
                  <BookmarkIcon className="h-3.5 w-3.5 mr-1" data-id="element-4219" />
                  <span data-id="element-4220">Save</span>
                </button>
                <button className="flex items-center text-xs hover:text-white" data-id="element-4221">
                  <MoreHorizontalIcon className="h-3.5 w-3.5" data-id="element-4222" />
                </button>
              </div>
            </div>
            {/* User Reply */}
            <div className="px-6 py-2 hover:bg-[#222529]" data-id="element-4223">
              <div className="flex items-start mb-1" data-id="element-4224">
                <div className="w-10 h-10 rounded-full mr-3 overflow-hidden flex-shrink-0" data-id="element-4225">
                  <div className="w-full h-full bg-[#3B82F6] flex items-center justify-center text-white font-bold" data-id="element-4226">
                    JS
                  </div>
                </div>
                <div data-id="element-4227">
                  <div className="flex items-center" data-id="element-4228">
                    <span className="font-bold text-white" data-id="element-4229">John Smith</span>
                    <span className="text-[#9B9B9B] text-xs ml-2" data-id="element-4230">9:34 AM</span>
                  </div>
                  <div className="mt-1 text-white" data-id="element-4231">
                    <p data-id="element-4232">
                      Thanks for the brief! Can you remind me what William
                      mentioned about the marketing budget in our last meeting?
                    </p>
                  </div>
                </div>
              </div>
              {/* Message Actions */}
              <div className="ml-12 mt-2 flex items-center space-x-3 text-[#9B9B9B]" data-id="element-4233">
                <button className="flex items-center text-xs hover:text-white" data-id="element-4234">
                  <SmileIcon className="h-3.5 w-3.5 mr-1" data-id="element-4235" />
                  <span data-id="element-4236">Add reaction</span>
                </button>
                <button className="flex items-center text-xs hover:text-white" data-id="element-4237">
                  <MessageSquareIcon className="h-3.5 w-3.5 mr-1" data-id="element-4238" />
                  <span data-id="element-4239">Reply in thread</span>
                </button>
              </div>
            </div>
            {/* Bot Reply */}
            <div className="px-6 py-2 hover:bg-[#222529]" data-id="element-4240">
              <div className="flex items-start mb-1" data-id="element-4241">
                <div className="w-10 h-10 rounded mr-3 overflow-hidden flex-shrink-0" data-id="element-4242">
                  <div className="w-full h-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] font-bold" data-id="element-4243">
                    PB
                  </div>
                </div>
                <div data-id="element-4244">
                  <div className="flex items-center" data-id="element-4245">
                    <span className="font-bold text-white" data-id="element-4246">Prepz Bot</span>
                    <span className="text-[#9B9B9B] text-xs ml-2" data-id="element-4247">9:35 AM</span>
                  </div>
                  <div className="mt-1 text-white" data-id="element-4248">
                    <p className="mb-2" data-id="element-4249">
                      In your last meeting with William (3 days ago), he shared
                      the Q3 performance metrics and specifically requested
                      preparation for questions about the marketing budget
                      allocation for Q4. He mentioned that they're considering
                      increasing the digital advertising budget by 30% based on
                      the strong performance in Q3.
                    </p>
                  </div>
                </div>
              </div>
              {/* Message Actions */}
              <div className="ml-12 mt-2 flex items-center space-x-3 text-[#9B9B9B]" data-id="element-4250">
                <button className="flex items-center text-xs hover:text-white" data-id="element-4251">
                  <ThumbsUpIcon className="h-3.5 w-3.5 mr-1" data-id="element-4252" />
                  <span data-id="element-4253">Add reaction</span>
                </button>
                <button className="flex items-center text-xs hover:text-white" data-id="element-4254">
                  <MessageSquareIcon className="h-3.5 w-3.5 mr-1" data-id="element-4255" />
                  <span data-id="element-4256">Reply</span>
                </button>
              </div>
            </div>
          </div>
          {/* Message Input */}
          <div className="bg-[#222529] p-3" data-id="element-4257">
            <div className="border border-[#565856] rounded-md bg-[#2C2C2C] p-2" data-id="element-4258">
              <div className="flex items-center" data-id="element-4259">
                <input type="text" placeholder="Message #meeting-prep" className="bg-transparent text-white flex-grow focus:outline-none" data-id="element-4260" />
                <div className="flex items-center space-x-2 text-[#9B9B9B]" data-id="element-4261">
                  <button data-id="element-4262">
                    <PlusCircleIcon className="h-5 w-5" data-id="element-4263" />
                  </button>
                  <button data-id="element-4264">
                    <PaperclipIcon className="h-5 w-5" data-id="element-4265" />
                  </button>
                  <button data-id="element-4266">
                    <SmileIcon className="h-5 w-5" data-id="element-4267" />
                  </button>
                  <button data-id="element-4268">
                    <SendIcon className="h-5 w-5" data-id="element-4269" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Integration Info */}
        <div className="max-w-4xl mx-auto bg-[#1A2331] rounded-lg p-6 border border-[#F5F7FA] border-opacity-10" data-id="element-4270">
          <h2 className="text-xl font-bold mb-4" data-id="element-4271">Integrate with Slack</h2>
          <p className="mb-4 text-[#F5F7FA] text-opacity-80" data-id="element-4272">
            Connect Prepz.io with Slack to receive AI-powered meeting briefs
            directly in your team's workspace. Get notified about upcoming
            meetings, access attendee information, and review business insights
            without leaving Slack.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-4273">
            <div className="bg-[#1E2A38] p-4 rounded-lg" data-id="element-4274">
              <div className="w-10 h-10 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-3" data-id="element-4275">
                <CalendarIcon className="h-5 w-5 text-[#C8F169]" data-id="element-4276" />
              </div>
              <h3 className="font-medium mb-2" data-id="element-4277">Meeting Notifications</h3>
              <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-4278">
                Get timely alerts about upcoming meetings directly in your Slack
                channels
              </p>
            </div>
            <div className="bg-[#1E2A38] p-4 rounded-lg" data-id="element-4279">
              <div className="w-10 h-10 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-3" data-id="element-4280">
                <UsersIcon className="h-5 w-5 text-[#C8F169]" data-id="element-4281" />
              </div>
              <h3 className="font-medium mb-2" data-id="element-4282">Attendee Research</h3>
              <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-4283">
                Access detailed profiles on meeting participants without
                switching apps
              </p>
            </div>
            <div className="bg-[#1E2A38] p-4 rounded-lg" data-id="element-4284">
              <div className="w-10 h-10 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-3" data-id="element-4285">
                <MessageSquareIcon className="h-5 w-5 text-[#C8F169]" data-id="element-4286" />
              </div>
              <h3 className="font-medium mb-2" data-id="element-4287">Interactive Bot</h3>
              <p className="text-sm text-[#F5F7FA] text-opacity-70" data-id="element-4288">
                Ask follow-up questions and get additional context through
                natural conversation
              </p>
            </div>
          </div>
          <div className="flex justify-center" data-id="element-4289">
            <button className="bg-[#C8F169] hover:bg-opacity-90 text-[#1E2A38] px-6 py-3 rounded-lg font-medium" data-id="element-4290">
              Connect with Slack
            </button>
          </div>
        </div>
      </main>
    </div>;
}